import React from "react";
import SEO from "../common/SEO";

const NoorPrivacyPolicy = () => {
  return (
    <>
      <SEO title="Noor - Islamic Companion Privacy Policy" />
      <main className="page-wrapper">
        {/* Simple Header with Logo (Non-clickable) */}
        <header className="rn-header header-default header-not-transparent sticky">
          <div className="container position-relative">
            <div className="row align-items-center row--0">
              <div className="col-lg-3 col-md-6 col-4">
                <div className="logo" style={{ display: "flex", alignItems: "center", height: "80px" }}>
                  <img
                    className="logo-light"
                    src={`${process.env.PUBLIC_URL}/images/logo/noor-logo.png`}
                    alt="Noor App Logo"
                    style={{ maxHeight: "60px", width: "auto" }}
                  />
                  <img
                    className="logo-dark"
                    src={`${process.env.PUBLIC_URL}/images/logo/noor-logo.png`}
                    alt="Noor App Logo"
                    style={{ maxHeight: "60px", width: "auto" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Privacy Policy Content */}
        <div className="rn-privacy-policy-area" style={{ paddingTop: "120px", paddingBottom: "60px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-left mb--30">
                  <h2 className="title">Privacy Policy for Noor - Islamic Companion</h2>
                  <p>Effective Date: February 26, 2026</p>
                </div>
                <div className="content">
                  <p>
                    At Noor - Islamic Companion, we believe that your spiritual journey is private. Our app is built with a "Privacy First" philosophy. This policy explains how we handle information.
                  </p>

                  <h4>1. No Data Collection (Server-Side)</h4>
                  <p>
                    We do not own or operate any servers that collect, store, or transmit your personal data.
                    <br />
                    We do not collect your name, email address, or phone number.
                    <br />
                    We do not track your "Mood" selections, your prayer history, or which Ayahs you read.
                    <br />
                    All your app settings and preferences are stored locally on your device.
                  </p>

                  <h4>2. Location Data (Athan & Qibla)</h4>
                  <p>
                    To provide accurate prayer times and Qibla direction, the app requires access to your device’s location.
                    <br />
                    <strong>Local Processing:</strong> Your location coordinates are used solely for offline mathematical calculations on your device.
                    <br />
                    <strong>No Tracking:</strong> Your location is never sent to us or any third party. It is not stored after the calculation is complete.
                  </p>

                  <h4>3. External Content & CDN</h4>
                  <p>
                    To keep the app size small, we use an external Content Delivery Network (CDN) to allow you to download Quran translations and reciter audio.
                    <br />
                    When you download this content, your device makes a request to the CDN.
                    <br />
                    These third-party providers may see your IP address (standard for any internet request), but they do not receive any personal information from the app.
                  </p>

                  <h4>4. Device Permissions</h4>
                  <p>
                    The app may request the following permissions for these specific reasons:
                    <br />
                    <strong>Location:</strong> To calculate Athan times and Qibla.
                    <br />
                    <strong>Storage/Media:</strong> To save downloaded Quran audio files and translations so you can use them offline.
                    <br />
                    <strong>Notifications:</strong> To alert you for Athan times (processed entirely by your device's OS).
                  </p>

                  <h4>5. Third-Party Services</h4>
                  <p>
                    We do not use third-party analytics (like Google Analytics or Firebase) or advertising networks that track your behavior.
                  </p>

                  <h4>6. Children’s Privacy</h4>
                  <p>
                    Because we do not collect any personal data, our app is safe for users of all ages, including children. We do not knowingly or unknowingly collect information from anyone.
                  </p>

                  <h4>7. Data Retention & Deletion</h4>
                  <p>
                    Since we do not store your data on our servers, we do not retain your personal information. All data (like prayer times settings and bookmarks) is stored locally on your device.
                    <br />
                    You can delete all your data at any time by simply uninstalling the app.
                  </p>

                  <h4>8. Changes to This Policy</h4>
                  <p>
                    If we ever decide to add features that require data collection (like cloud syncing), we will update this policy and notify you within the app.
                  </p>

                  <h4>9. Contact Us</h4>
                  <p>
                    If you have any questions about this Privacy Policy, please contact us at:
                    <br />
                    <a href="mailto:support@moftahsolutions.com">support@moftahsolutions.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Simple Footer */}
        <div className="copyright-area copyright-style-one variation-two">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="copyright-right text-center">
                  <p className="copyright-text">
                    © Moftah Solutions, LLC {new Date().getFullYear()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default NoorPrivacyPolicy;
